import { fork, cancel, takeEvery, getContext, setContext } from 'redux-saga/effects';
function* filterActions(saga, getKey, ...args) {
    const key = getKey(...args);
    const tasks = yield getContext('takeLatestByTasks');
    const previousTask = tasks[key];
    if (previousTask) {
        yield cancel(previousTask);
    }
    tasks[key] = yield fork(saga, ...args);
}
/**
 * takeLatestBy effect works similar to takeLatest, in a sense that it will
 * cancel previous task if it's already running, but allows for grouping task
 * by key that we provide. This means that we can have different buckets of
 * takeLatest for different action keys.
 **/ export function* takeLatestBy(patternOrChannel, saga, getKey, ...args) {
    const takeLatestByTasks = yield getContext('takeLatestByTasks');
    if (!takeLatestByTasks) yield setContext({
        takeLatestByTasks: {}
    });
    yield takeEvery(patternOrChannel, filterActions, saga, getKey, ...args);
}
export default takeLatestBy;

//# sourceMappingURL=takeLatestBy.js.map